import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import BlogsList from './BlogsList';
import {connect} from 'react-redux';
import {withTranslation} from "react-i18next";

class SidebarContent extends Component {

    static propTypes = {
        changeToDark: PropTypes.func.isRequired,
        changeToLight: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired
    };

    hideSidebar = () => {
        const {onClick} = this.props;
        onClick();
    };

    render() {
        const {changeToDark, changeToLight, t} = this.props;
        return (
            <div className="sidebar__content">
                <ul className="sidebar__block">
                    <SidebarLink icon="user" title={t('menu.overview')} route="/" onClick={this.hideSidebar}/>
                </ul>

                <ul className="sidebar__block">
                    <BlogsList icon="code"/>
                </ul>
                {this.props.blog._id && (
                    <ul className="sidebar__block">
                        <SidebarLink icon="pencil" title={t('menu.write_new')} route="/write" onClick={this.hideSidebar}/>
                        <SidebarLink icon="menu" title={t('menu.blog_posts')} route="/drafts" onClick={this.hideSidebar}/>
                        <SidebarLink icon="cog" title={t('menu.blog_settings')} route="/settings" onClick={this.hideSidebar}/>
                    </ul>)}

                <ul className="sidebar__block">
                    <SidebarCategory title={t('menu.marketplace')} icon="cart">
                        <SidebarLink title={t('menu.domains')} route="/domains" onClick={this.hideSidebar}/>
                    </SidebarCategory>
                </ul>

                <ul className="sidebar__block">
                    <SidebarLink icon="diamond" title={t('menu.wallet')} route="/wallet" onClick={this.hideSidebar}/>
                    <SidebarCategory title={t('menu.colors')} icon="moon">
                        <button type="button" className="sidebar__link" onClick={changeToLight}>
                            <p className="sidebar__link-title">{t('menu.color.light')}</p>
                        </button>
                        <button type="button" className="sidebar__link" onClick={changeToDark}>
                            <p className="sidebar__link-title">{t('menu.color.dark')}</p>
                        </button>
                    </SidebarCategory>
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blog: state.blogs.blog
    }
}

export default connect(mapStateToProps)(withTranslation('dashboard')(SidebarContent));
